import React, { useState, useEffect } from 'react';
import viral from "../assests/Premium Fish Feed with Sapphire Splash Background.png"
import mrigal from "../assests/Premium Fish Feed with Sapphire Splash Background (5).png"
import talapia from "../assests/Premium Fish Feed with Sapphire Splash Background (4).png"
import fungash from "../assests/Premium Fish Feed with Sapphire Splash Background (3).png"
import Catla from "../assests/Premium Fish Feed with Sapphire Splash Background (2).png"
import Rohu from "../assests/Premium Fish Feed with Sapphire Splash Background (1).png"
import { FaWhatsapp,FaFish, FaHeart, FaRegHeart, FaStar, FaHome, FaUser, FaShoppingBag, FaBox, FaMapMarkerAlt, FaCreditCard, FaQuestionCircle, FaCog, FaPhone } from 'react-icons/fa';


const fishFeedProducts = [
  {
    id: 1,
    name: 'Viral Fish Feed Bag',
    category: 'Premium',
    weight: '25kg',
         protein: 'Protein 48%',
    price: 1850,
    oldPrice: 2100,
    description: 'High-protein feed for rapid growth and immunity boost',
    image: viral,
    badge: 'Best Seller',
    rating: 4.8,
    reviews: 124
  },
  {
    id: 2,
    name: 'Rohu Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
         protein: 'Protein 28%',

    price: 1350,
    oldPrice: 1900,
    description: 'Specially formulated for Rohu fish growth and health',
    image: Rohu,
    badge: 'Popular',
    rating: 4.6,
    reviews: 89
  },
  {
    id: 3,
    name: 'Catla Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
         protein: 'Protein 28%',

    price: 1350,
    oldPrice: 1900,
    description: 'Optimized nutrition for Catla fish species',
    image: Catla,
    badge: null,
    rating: 4.5,
    reviews: 67
  },
  {
    id: 4,
    name: 'Fungash Fish Feed Bag',
    category: 'Premium',
    weight: '25kg',
         protein: 'Protein 28%',

    price: 1350,
    oldPrice: 2000,
    description: 'Enhanced formula for fungal resistance and growth',
    image: fungash,
    badge: 'New',
    rating: 4.7,
    reviews: 45
  },
  {
    id: 5,
    name: 'Tilapia Fish Feed Bag',
    category: 'Standard',
    weight: '25kg',
         protein: 'Protein 28%',

    price: 1350,
    oldPrice: 1800,
    description: 'Balanced nutrition for Tilapia farming',
    image: talapia,
    badge: null,
    rating: 4.4,
    reviews: 112
  },
  {
    id: 6,
    name: 'Mrigal Fish Feed Bag',
    category: 'Specialty',
    weight: '25kg',
         protein: 'Protein 28%',

    price: 1350,
    oldPrice: 1850,
    description: 'Specialized feed for Mrigal fish species',
    image: mrigal,
    badge: null,
    rating: 4.5,
    reviews: 56
  },
   {
    id: 7,
    name: 'Viral Fish Feed Bag',
    category: 'Premium',
    weight: '40kg',
         protein: 'Protein 48%',
    price: 2880,
    oldPrice: 3860,
    description: 'High-protein feed for rapid growth and immunity boost',
    image: viral,
    badge: 'Best Seller',
    rating: 4.8,
    reviews: 124
  },
   {
    id: 8,
    name: 'Rohu Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
         protein: 'Protein 28%',

    price: 1680,
    oldPrice: 2160,
    description: 'Specially formulated for Rohu fish growth and health',
    image: Rohu,
    badge: 'Popular',
    rating: 4.6,
    reviews: 89
  },
  {
    id: 9,
    name: 'Catla Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
         protein: 'Protein 28%',

    price: 1680,
    oldPrice: 2160,
    description: 'Optimized nutrition for Catla fish species',
    image: Catla,
    badge: null,
    rating: 4.5,
    reviews: 67
  },
  {
    id: 10,
    name: 'Fungash Fish Feed Bag',
    category: 'Premium',
    weight: '40kg',
         protein: 'Protein 28%',

    price: 1680,
    oldPrice: 2160,
    description: 'Enhanced formula for fungal resistance and growth',
    image: fungash,
    badge: 'New',
    rating: 4.7,
    reviews: 45
  },
  {
    id: 11,
    name: 'Tilapia Fish Feed Bag',
    category: 'Standard',
    weight: '40kg',
         protein: 'Protein 28%',

    price: 1680,
    oldPrice: 2160,
    description: 'Balanced nutrition for Tilapia farming',
    image: talapia,
    badge: null,
    rating: 4.4,
    reviews: 112
  },
  {
    id: 12,
    name: 'Mrigal Fish Feed Bag',
    category: 'Specialty',
    weight: '40kg',
         protein: 'Protein 28%',

    price: 1680,
    oldPrice: 2160,
    description: 'Specialized feed for Mrigal fish species',
    image: mrigal,
    badge: null,
    rating: 4.5,
    reviews: 56
  },
];

const FishFeedApp = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [wishlist, setWishlist] = useState([]);
  const [activeTab, setActiveTab] = useState('home');
  const [showSheet, setShowSheet] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const categories = ['All', 'Premium', 'Specialty', 'Standard'];

  const filteredProducts = selectedCategory === 'All' 
    ? fishFeedProducts 
    : fishFeedProducts.filter(product => product.category === selectedCategory);

  const formatPrice = (price) => `₹${price.toLocaleString('en-IN')}`;

  const toggleWishlist = (productId) => {
    if (wishlist.includes(productId)) {
      setWishlist(wishlist.filter(id => id !== productId));
    } else {
      setWishlist([...wishlist, productId]);
    }
  };

  const handleWhatsAppEnquiry = (product) => {
    const message = `Hi, I'm interested in ${product.name} (${product.weight}). Price: ${formatPrice(product.price)}. Please share more details.`;
    const whatsappUrl = `https://wa.me/918072621187?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const openProductSheet = (product) => {
    if (isMobile) {
      setSelectedProduct(product);
      setShowSheet(true);
      document.body.style.overflow = 'hidden';
    }
  };

  const closeSheet = () => {
    setShowSheet(false);
    setSelectedProduct(null);
    document.body.style.overflow = 'auto';
  };

  // Product Card Component (Reusable)
  const ProductCard = ({ product, showActions = true }) => (
    <div
      className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 ${
        isMobile ? 'active:scale-[0.98] cursor-pointer' : 'hover:-translate-y-1'
      }`}
      onClick={() => isMobile && openProductSheet(product)}
    >
      {/* Badge */}
      {product.badge && (
        <span className={`absolute z-10 mt-3 ml-3 px-3 py-1 rounded-full text-xs font-bold text-white ${
          product.badge === 'Best Seller' ? 'bg-orange-500' :
          product.badge === 'New' ? 'bg-green-500' : 'bg-blue-500'
        }`}>
          {product.badge}
        </span>
      )}
      
      <div className="relative">
        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-56 object-contain bg-gray-50"
        />
        <button
          onClick={(e) => {
            e.stopPropagation();
            toggleWishlist(product.id);
          }}
          className="absolute top-3 right-3 w-10 h-10 bg-white/90 backdrop-blur rounded-full flex items-center justify-center shadow-md hover:scale-110 transition"
        >
          <span className="text-xl">{wishlist.includes(product.id) ? '❤️' : '🤍'}</span>
        </button>
      </div>
      
      <div className="p-4">
        <div className="flex justify-between items-start mb-1">
          <h3 className="font-bold text-gray-800 text-lg">{product.name}</h3>
          <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">{product.weight}</span>

        </div>
        
        <div className="flex items-center gap-1 mb-2">
          <span className="text-yellow-500">⭐</span>
          <span className="text-sm font-medium text-gray-700">{product.rating}</span>
          <span className="text-xs text-gray-400">({product.reviews} reviews)</span>
                   <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">{product.protein}</span>

        </div>
        
        <p className="text-gray-500 text-sm mb-3 line-clamp-2">{product.description}</p>
        
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xl font-bold text-green-700">{formatPrice(product.price)}</span>
          <span className="text-sm text-gray-400 line-through">{formatPrice(product.oldPrice)}</span>
          <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full">
            {Math.round(((product.oldPrice - product.price) / product.oldPrice) * 100)}% OFF
          </span>
        </div>
        
        <button
          onClick={(e) => {
            e.stopPropagation();
            handleWhatsAppEnquiry(product);
          }}
          className="w-full bg-green-500 text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2 hover:bg-green-600 transition"
        >
          <FaWhatsapp/> Enquire on WhatsApp
        </button>
      </div>
    </div>
  );

  // Home Tab Component (Mobile)
  const MobileHomeTab = () => (
    <>
      {/* Hero Section */}
      <div className="relative bg-[#1770b6] px-5 pt-10 pb-12 rounded-b-3xl overflow-hidden">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center">
<h1 className="text-3xl font-bold text-white mb-2 flex items-center justify-center gap-2">
  Premium Fish Feed <FaFish className="text-white text-3xl" />
</h1>          <p className="text-white/90 text-sm mb-5">High-quality nutrition for healthy & fast-growing fish</p>
          <div className="flex justify-center gap-3 flex-wrap">
            <span className="bg-white/20 px-4 py-1.5 rounded-full text-xs font-medium text-white">6+ Varieties</span>
            <span className="bg-white/20 px-4 py-1.5 rounded-full text-xs font-medium text-white">25kg Bags</span>
            <span className="bg-white/20 px-4 py-1.5 rounded-full text-xs font-medium text-white">Free Delivery</span>
          </div>
        </div>
      </div>

      {/* Category Scroll - Horizontal */}
      <div className="sticky top-0 z-10 bg-white border-b border-gray-100 py-3">
        <div className="flex gap-1 overflow-x-auto px-2 scrollbar-hide">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                selectedCategory === category
                  ? 'bg-green-600 text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Products Grid */}
      <div className="px-4 py-5 pb-24 space-y-4">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </>
  );

  // Desktop Home Tab (Full Responsive)
  const DesktopHomeTab = () => (
    <div className="max-w-7xl mx-auto px-6 py-8">
      {/* Hero Section */}
      <div className="relative bg-[#1770b6] rounded-3xl overflow-hidden mb-12">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 text-center py-16 px-8">
<h1 className="text-4xl font-bold text-white mb-2 flex items-center justify-center gap-2">
  Premium Fish Feed <FaFish className="text-white text-4xl" />
</h1>          <p className="text-white/90 text-lg mb-6 max-w-2xl mx-auto">
            High-quality nutrition for healthy & fast-growing fish
          </p>
          <div className="flex justify-center gap-4 flex-wrap">
            <span className="bg-white/20 px-5 py-2 rounded-full text-sm font-medium text-white">6+ Varieties</span>
            <span className="bg-white/20 px-5 py-2 rounded-full text-sm font-medium text-white">25kg Bags</span>
            <span className="bg-white/20 px-5 py-2 rounded-full text-sm font-medium text-white">Free Delivery</span>
            <span className="bg-white/20 px-5 py-2 rounded-full text-sm font-medium text-white">Premium Quality</span>
          </div>
        </div>
      </div>

      {/* Category Filters */}
      <div className="flex flex-wrap gap-3 mb-8">
        {categories.map(category => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`px-6 py-2.5 rounded-full text-sm font-medium transition-all ${
              selectedCategory === category
                ? 'bg-green-600 text-white shadow-md'
                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
            }`}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Products Grid - Desktop 3-4 Columns */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {filteredProducts.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );

  // Wishlist Tab (Desktop)
  const DesktopWishlistTab = () => {
    const wishlistProducts = fishFeedProducts.filter(p => wishlist.includes(p.id));
    
    return (
      <div className="max-w-7xl mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">My Wishlist ❤️</h2>
        {wishlistProducts.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 bg-white rounded-2xl">
            <span className="text-7xl mb-4">🤍</span>
            <p className="text-gray-500 text-lg mb-5">No items in wishlist</p>
            <button
              onClick={() => setSelectedCategory('All')}
              className="bg-green-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-green-700 transition"
            >
              Browse Products
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {wishlistProducts.map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    );
  };

  // Profile Tab (Desktop)
  const DesktopProfileTab = () => (
    <div className="max-w-4xl mx-auto px-6 py-8">
      <div className="bg-[#1770b6] rounded-2xl p-8 text-center mb-8">
        <div className="w-28 h-28 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-6xl">👤</span>
        </div>
        <h3 className="text-2xl font-bold text-white">Fish Farmer</h3>
        <p className="text-white/80">+91 98765 43210</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="bg-white rounded-xl p-5 text-center shadow-sm">
          <span className="text-2xl font-bold text-gray-800">6</span>
          <p className="text-gray-500 text-sm mt-1">Products</p>
        </div>
        <div className="bg-white rounded-xl p-5 text-center shadow-sm">
          <span className="text-2xl font-bold text-gray-800">{wishlist.length}</span>
          <p className="text-gray-500 text-sm mt-1">Wishlist</p>
        </div>
        <div className="bg-white rounded-xl p-5 text-center shadow-sm">
          <span className="text-2xl font-bold text-gray-800">4.8</span>
          <p className="text-gray-500 text-sm mt-1">Rating</p>
        </div>
      </div>
      
      <div className="bg-white rounded-xl overflow-hidden shadow-sm">
        {['📦 My Orders', '📍 Delivery Address', '💳 Payment Methods', '❓ Help & Support', '⚙️ Settings'].map((item, index) => (
          <div key={index} className="px-6 py-4 border-b border-gray-100 last:border-0 text-gray-700 hover:bg-gray-50 transition cursor-pointer">
            {item}
          </div>
        ))}
      </div>
    </div>
  );

  // Mobile Bottom Sheet Modal
  const ProductSheet = () => (
    <>
      {showSheet && (
        <div 
          className="fixed inset-0 bg-black/50 z-50 transition-opacity"
          onClick={closeSheet}
        />
      )}
      <div 
        className={`fixed bottom-10 left-0 right-0 bg-white rounded-t-3xl z-50 transition-transform duration-300 ${
          showSheet ? 'translate-y-0' : 'translate-y-full'
        }`}
      >
        {selectedProduct && (
          <>
            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-4" />
            <img 
              src={selectedProduct.image} 
              alt={selectedProduct.name}
              className="w-full h-56 object-contain bg-gray-50"
            />
            <div className="p-5 pb-8">
              <h2 className="text-xl font-bold text-gray-800">{selectedProduct.name}</h2>
              <span className="text-sm text-gray-500 bg-gray-100 px-2 py-1 rounded-full inline-block mt-1">
                {selectedProduct.weight}
              </span>
              <div className="flex items-center gap-2 mt-3">
                <span className="text-2xl font-bold text-green-700">{formatPrice(selectedProduct.price)}</span>
                <span className="text-sm text-gray-400 line-through">{formatPrice(selectedProduct.oldPrice)}</span>
              </div>
              <p className="text-gray-600 text-sm mt-3 leading-relaxed">{selectedProduct.description}</p>
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => handleWhatsAppEnquiry(selectedProduct)}
                  className="flex-1 bg-green-500 text-white py-3 rounded-xl font-semibold text-sm flex items-center justify-center gap-2"
                >
                  📞 Enquire Now
                </button>
                <button
                  onClick={() => toggleWishlist(selectedProduct.id)}
                  className={`px-5 py-3 rounded-xl border font-semibold text-sm transition ${
                    wishlist.includes(selectedProduct.id)
                      ? 'border-red-300 bg-red-50 text-red-500'
                      : 'border-gray-300 text-gray-600'
                  }`}
                >
                  {wishlist.includes(selectedProduct.id) ? '❤️' : '🤍'}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );

  // Mobile Bottom Navigation
  const MobileBottomNav = () => (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-40">
      <div className="flex justify-around py-2">
        <button
          onClick={() => setActiveTab('home')}
          className={`flex flex-col items-center py-1 px-5 rounded-full transition ${
            activeTab === 'home' ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          <span className="text-2xl">🏠</span>
          <span className="text-xs mt-0.5 font-medium">Home</span>
        </button>
        <button
          onClick={() => setActiveTab('wishlist')}
          className={`flex flex-col items-center py-1 px-5 rounded-full transition relative ${
            activeTab === 'wishlist' ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          <span className="text-2xl">❤️</span>
          <span className="text-xs mt-0.5 font-medium">Wishlist</span>
          {wishlist.length > 0 && (
            <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
              {wishlist.length}
            </span>
          )}
        </button>
        <button
          onClick={() => setActiveTab('profile')}
          className={`flex flex-col items-center py-1 px-5 rounded-full transition ${
            activeTab === 'profile' ? 'text-green-600' : 'text-gray-400'
          }`}
        >
          <span className="text-2xl">👤</span>
          <span className="text-xs mt-0.5 font-medium">Profile</span>
        </button>
      </div>
    </div>
  );

  // Mobile Floating WhatsApp Button
  const MobileWhatsAppBtn = () => (
    <a
      href="https://wa.me/918072621187?text=Hi%2C%20I'm%20interested%20in%20your%20fish%20feed%20products"
      className="fixed bottom-20 right-4 bg-green-500 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition z-40"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className='h-10 w-auto'/>
    </a>
  );

  // Desktop Floating WhatsApp Button
  const DesktopWhatsAppBtn = () => (
    <a
      href="https://wa.me/918072621187?text=Hi%2C%20I'm%20interested%20in%20your%20fish%20feed%20products"
      className="fixed bottom-8 right-8 bg-green-500 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:bg-green-600 transition z-40 hover:scale-105"
      target="_blank"
      rel="noopener noreferrer"
    >
      <FaWhatsapp className='h-10 w-auto'/>
    </a>
  );

  // Desktop Navigation
 

  return (
    <>
      {isMobile ? (
        /* ========== MOBILE VIEW ========== */
        <div className="max-w-md mx-auto bg-gray-50 min-h-screen relative shadow-xl">
          {/* Main Content */}
          <div>
            {activeTab === 'home' && <MobileHomeTab />}
            {activeTab === 'wishlist' && <DesktopWishlistTab />}
            {activeTab === 'profile' && <DesktopProfileTab />}
          </div>

          {/* Mobile Bottom Navigation */}
          {/* <MobileBottomNav /> */}

          {/* Mobile Floating WhatsApp Button */}
          <MobileWhatsAppBtn />

          {/* Bottom Sheet */}
          <ProductSheet />
        </div>
      ) : (
        /* ========== DESKTOP VIEW ========== */
        <div className="min-h-screen bg-gray-50">
          {/* <DesktopNav /> */}
          
          {/* Main Content */}
          <div>
            {activeTab === 'home' && <DesktopHomeTab />}
            {activeTab === 'wishlist' && <DesktopWishlistTab />}
            {activeTab === 'profile' && <DesktopProfileTab />}
          </div>

          {/* Desktop Floating WhatsApp Button */}
          <DesktopWhatsAppBtn />
        </div>
      )}
    </>
  );
};

export default FishFeedApp;
